import type { CashAndBankRepository } from "../repositories/CashAndBankRepository";
import type { WeeklyCashFlowEntity } from "../entities/WeeklyCashFlowEntity";
import type { GetWeeklyCashFlowParams } from "../repositories/CashAndBankRepository";

export class GetWeeklyCashFlowUseCase {
  constructor(private readonly repository: CashAndBankRepository) {}

  async execute(params?: GetWeeklyCashFlowParams): Promise<WeeklyCashFlowEntity> {
    return this.repository.getWeeklyCashFlow(params);
  }
}
